<!-- <ul class="layout-menu">
  <ng-container *ngFor="let item of items; let i = index;">
    <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
    <li *ngIf="item.separator" class="menu-separator"></li>
  </ng-container>
</ul> -->

<div class="menu">
  <div class="menu__links">
    <ul class="menu__items">
      <ng-container *ngFor="let item of items; let i = index;">
        <li app-menuitem *ngIf="!item.separator" [item]="item" [index]="i" [root]="true"></li>
      </ng-container>
    </ul>
  </div>
</div>